<template>
  <div v-if="isDataLoaded && dataReady" >
    <div class="full-width">
      <p class="card-title">
        {{ getString('module.dashboard.stats.syncitems') }}
      </p>
      <div class="card-block scroll">
        <div class="row">
          <div class="col">
            <b>{{ getString('module.dashboard.stats.items') }}</b>
            <h5 class="q-mt-md q-mb-sm">
              {{ data.items }}
            </h5>
          </div>
          <div class="col">
            <b>{{ getString('module.dashboard.stats.files') }}</b>
            <h5 class="q-mt-md q-mb-sm">
              {{ data.files }}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'syncInfo',
    };
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
